export enum CareIssuesRoutesTypes {
  SELECT_ISSUE = 'careIssuesSelect',
}
